import {
  Box,
  Collapse,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import React, { useEffect, useMemo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
import HistoryIcon from '@material-ui/icons/History'
import { useDispatch, useSelector } from 'react-redux'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import { useConfirm } from 'material-ui-confirm'

import { SNACKBAR } from '../../../main/MainActions'
import { edit, getHistory } from '../../AttendanceActions'
import {
  applyDiscount,
  dateFormatedFullDate,
  exportFormatedMoney,
  getPercetageApplicated,
} from '../../../../util/utils'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import { mdiContentCopy, mdiHistory } from '@mdi/js'
import Icon from '@mdi/react'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../../components/hooks/BaseTableComponents'
import colors from '../../../../assets/colors'

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
    backgroundColor: colors.primary,
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  table: {
    padding: theme.spacing(2),
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  // Mesmo visual do botão "Confira a agenda da semana", que fica ao lado
  btnHistoric: {
    whiteSpace: 'nowrap',
    color: '#FFFF',
    fontSize: '14px',
    backgroundColor: colors.primary,
    borderRadius: '10px',
    padding: '4px 12px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      opacity: 0.6,
      backgroundColor: colors.primary,
    },
  },
}))

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
})

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />
})

const Historic = ({ disabled, clientId, fillNewServices }) => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)
  const historic = useSelector(state => state.attendance.historic)
  const confirm = useConfirm()

  const filterClasses = filterStylesComponents()

  const dispatch = useDispatch()

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  function createData(
    id,
    id_laundry_client,
    createdAt,
    totalWithDiscount,
    totalWithoutDiscount,
    totalHours,
    status,
    generalDiscount,
    sallesMan,
    services
  ) {
    return {
      id,
      id_laundry_client,
      createdAt,
      totalWithDiscount,
      totalWithoutDiscount,
      totalHours,
      status,
      generalDiscount,
      sallesMan,
      services,
    }
  }

  const rows = []

  historic?.map(row => {
    rows.push(
      createData(
        row.id,
        row.id_laundry_client,
        row.created_at,
        row.total_with_discount,
        row.total_without_discount,
        row.total_hours,
        row.status,
        row.general_discount,
        row.attendant_name,
        row.services
      )
    )
  })

  const confirmCopy = id => {
    confirm({
      description: `Deseja realmente copiar os itens da OS ${id} para a nova OS?`,
      title: 'Tem certeza?',
      confirmationText: 'Sim',
      cancellationText: 'Cancelar',
      dialogProps: {
        fullWidth: true,
      },
    }).then(async () => {
      const item = historic.find(x => x.id === id)

      const { data } = await dispatch(edit(item.id))

      fillNewServices(data, item?.services)
      setOpen(false)

      dispatch({
        type: SNACKBAR.SOFTSUCCESS,
        success: { message: 'A Nova OS foi populada com os itens' },
      })
    })
  }

  function Row(props) {
    const { row } = props

    const { services = [{ default_value: 0, quantity: 0, discount: 0 }] } = row

    const [open, setOpen] = React.useState(false)
    const classes = useRowStyles()

    const values = useMemo(() => {
      if (!services?.length)
        return {
          discount_applied: 0,
          total_with_discount: 0,
          total_without_discount: 0,
        }

      const totalWithDiscount = services?.reduce((total, item) => {
        const { default_value = 0, quantity = 0, discount = 0 } = item
        const value = parseFloat(default_value * parseFloat(quantity))
        const valueDiscount = applyDiscount(value, discount)
        return total + valueDiscount
      }, 0)

      const totalWithoutDiscount = services?.reduce((total, item) => {
        const { default_value = 0, quantity = 0 } = item
        return total + parseFloat(default_value * parseFloat(quantity))
      }, 0)

      const discountApplied = (
        getPercetageApplicated(totalWithoutDiscount, totalWithDiscount) || 0
      ).toFixed(2)

      return {
        discount_applied: discountApplied,
        total_with_discount: totalWithDiscount,
        total_without_discount: totalWithoutDiscount,
      }
    }, [services])

    return (
      <>
        <TableRow className={classes.root}>
          <StyledTableCellBody>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </StyledTableCellBody>
          <StyledTableCellBody component="th" scope="row">
            {row.id_laundry_client}
          </StyledTableCellBody>
          <StyledTableCellBody>
            {dateFormatedFullDate(row.createdAt)}
          </StyledTableCellBody>
          <StyledTableCellBody>
            {exportFormatedMoney(values.total_with_discount)}
          </StyledTableCellBody>
          <StyledTableCellBody>
            {exportFormatedMoney(values.total_without_discount)}
          </StyledTableCellBody>
          <StyledTableCellBody>{`${values.discount_applied}%`}</StyledTableCellBody>
          <StyledTableCellBody>{row.totalHours}</StyledTableCellBody>
          <StyledTableCellBody>{row?.services?.length}</StyledTableCellBody>
          <StyledTableCellBody>{row.status}</StyledTableCellBody>
          <StyledTableCellBody>{row.sallesMan}</StyledTableCellBody>
          <StyledTableCellBody align="right">
            <IconButton
              onClick={() => confirmCopy(row.id)}
              className={filterClasses.btnSalvar}
            >
              <Icon path={mdiContentCopy} size={1} />
            </IconButton>
          </StyledTableCellBody>
        </TableRow>
        <TableRow>
          <StyledTableCellBody
            style={{ paddingBottom: 0, paddingTop: 0 }}
            colSpan={11}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div">
                  Itens
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <StyledTableCellHeader />
                      <StyledTableCellHeader>ID</StyledTableCellHeader>
                      <StyledTableCellHeader align="right">
                        Valor
                      </StyledTableCellHeader>
                      <StyledTableCellHeader align="right">
                        Desconto
                      </StyledTableCellHeader>
                      <StyledTableCellHeader align="right">
                        Tempo de Ex
                      </StyledTableCellHeader>
                      <StyledTableCellHeader>Serviço</StyledTableCellHeader>
                      <StyledTableCellHeader>
                        Quantidade/Tamanho
                      </StyledTableCellHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.services.map(service => (
                      <TableRow key={`row-service-item-${service.id}`}>
                        <StyledTableCellBody component="th" scope="row" />
                        <StyledTableCellBody>{service.id}</StyledTableCellBody>
                        <StyledTableCellBody align="right">
                          {exportFormatedMoney(service.final_value)}
                        </StyledTableCellBody>
                        <StyledTableCellBody align="right">
                          {service.discount}
                        </StyledTableCellBody>
                        <StyledTableCellBody align="right">
                          {service.execution_time}
                        </StyledTableCellBody>
                        <StyledTableCellBody>
                          {service.name}
                        </StyledTableCellBody>
                        <StyledTableCellBody>
                          {service.quantity}
                        </StyledTableCellBody>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </StyledTableCellBody>
        </TableRow>
      </>
    )
  }

  useEffect(() => {
    if (open && clientId) dispatch(getHistory(clientId))
  }, [open])

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleClickOpen}
        disabled={disabled}
        className={classes.btnHistoric}
      >
        <Icon path={mdiHistory} size={1} style={{ marginRight: '4px' }} />
        {!disabled && 'Histórico de atendimentos'}
      </IconButton>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Histórico do cliente
            </Typography>
          </Toolbar>
        </AppBar>
        <Paper elevation={0}>
          <TableContainer className={classes.table}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <StyledTableCellHeader />
                  <StyledTableCellHeader>ID</StyledTableCellHeader>
                  <StyledTableCellHeader>Data</StyledTableCellHeader>
                  <StyledTableCellHeader>Total c/ desc</StyledTableCellHeader>
                  <StyledTableCellHeader>Total s/ desc</StyledTableCellHeader>
                  <StyledTableCellHeader>Desc</StyledTableCellHeader>
                  <StyledTableCellHeader>Total Horas</StyledTableCellHeader>
                  <StyledTableCellHeader>Itens</StyledTableCellHeader>
                  <StyledTableCellHeader>Status</StyledTableCellHeader>
                  <StyledTableCellHeader>Vendedor</StyledTableCellHeader>
                  <StyledTableCellHeader align="right">
                    Ações
                  </StyledTableCellHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(row => (
                  <Row key={`row-services-${row.id}`} row={row} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Dialog>
    </div>
  )
}

export default React.memo(Historic)
